import React, { useState, useRef, useEffect, useCallback } from "react";
import "react-simple-keyboard/build/css/index.css";
import cn from "classnames";
import { LABEL, CUSTOM_MESSAGES } from "../../veriables";
import Keyboard from "@components/KeyboardV2";
import { APP_CONFIG } from "@constants";
import { urlSearchParams, getObjectValue } from "../../utility/utills";
import { ReactComponent as Cross } from "@assets/images/cross.svg";
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import GiftCardBalanceScreen from './GiftCardBalanceScreen';
import { connect } from "react-redux";

const GiftCardLandscapeMode = (props) => {
  const {
    isSecurityCode,
    onSubmit,
    giftCardSupportsSwipe,
    openCardPopUp,
    handleGiftCancel,
    setPaymentType,
    tableData,
    serverAppTheme,
    setPayModeType,
    giftCardBalanceInfo,
    giftCardBalanceCheck,
    giftCardNumber,
    paymentAmount,
    showCheckSeat,
    paymentLandscapeOrientation
  } = props;

  const showCheckSeatVar = showCheckSeat && showCheckSeat();

  const [activeElement, setActiveElement] = useState("cardNumber");
  const [inputs, setInputs] = useState({ cardNumber: "", securityCode: "" });
  const [typed, setTyped] = useState({ cardNumber: "", securityCode: "" });
  const [showBalanceScreen, setShowBalanceScreen] = useState(false);
  const keyboard = useRef(null);
  const ref = useRef(null);
  const previousBalanceInfoRef = useRef(null);
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;
  const typedRef = useRef(typed);
  typedRef.current = typed;
  const currencySymbol = LABEL().CURRENCY_SYMBOL;

  useEffect(() => {
    handleGiftCancel?.(true);
    setShowBalanceScreen(false);
    setInputs({ cardNumber: "", securityCode: "" });
    setTyped({ cardNumber: "", securityCode: "" });
    previousBalanceInfoRef.current = null;
  }, []);

  useEffect(() => {
    if (giftCardBalanceInfo?.accountNumber) {
      const isNewBalanceInfo =
        !previousBalanceInfoRef.current ||
        previousBalanceInfoRef.current.accountNumber !== giftCardBalanceInfo.accountNumber;

      if (isNewBalanceInfo) {
        setShowBalanceScreen(true);
        previousBalanceInfoRef.current = giftCardBalanceInfo;
      }
    } else if (!giftCardBalanceInfo && previousBalanceInfoRef.current) {
      setShowBalanceScreen(false);
      previousBalanceInfoRef.current = null;
    }
  }, [giftCardBalanceInfo]);

  const handleErrorPopUp = (message) => {
    props.setErrorPopUp({
      res: message,
      noErrorTxt: true,
    });
  };

  const onClickBtn = useCallback((e) => {
    const currentTyped = typedRef.current;
    const currentInputs = inputsRef.current;
    const newTyped = e === "{bksp}"
      ? { ...currentTyped, [activeElement]: currentTyped[activeElement]?.slice(0, -1) }
      : {
        ...currentTyped,
        [activeElement]: currentTyped[activeElement]
          ? currentTyped[activeElement].concat(e)
          : "".concat(e),
      };
    setTyped(newTyped);
    setInputs({
      ...currentInputs,
      [activeElement]: newTyped[activeElement],
    });
  }, [activeElement]);

  const handleSetInputEmpty = useCallback(() => {
    setInputs((prev) => ({ ...prev, [activeElement]: "" }));
    setTyped((prev) => ({ ...prev, [activeElement]: "" }));
  }, [activeElement]);

  const handleBlur = () => {
    if (document.querySelector("#cardNumber")) {
      document.querySelector("#cardNumber").blur();
    }
    if (document.querySelector("#securityCode")) {
      document.querySelector("#securityCode").blur();
    }
  };

  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: "",
    });
    setTyped({
      ...typed,
      [data]: "",
    });
  };

  const handleChangeInput = (data) => {
    if (keyboard.current) {
      keyboard.current.setInput(inputs[data], data);
    }
  };

  const getInput = (key) => {
    return inputs[key];
  };

  const type = urlSearchParams('type');

  const handleBackButton = () => {
    const screenType = type === "giftCardPay" ? 32 : 31;
    const typeParam = urlSearchParams("ticketSplitTypeId") === "1" ? "payType" : "splitType";

    setPaymentType(type === "giftCardPay" ? 32 : 31);
    setPayModeType(LABEL().DEFAULT_PAY);
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=${screenType}&type=${typeParam}`,
      { replace: true }
    );
  };

  if (showBalanceScreen && giftCardBalanceInfo) {
    return (
      <GiftCardBalanceScreen
        giftCardInfo={giftCardBalanceInfo}
        onDontUse={() => {
          setShowBalanceScreen(false);
          setInputs({ cardNumber: "", securityCode: "" });
          setTyped({ cardNumber: "", securityCode: "" });
          previousBalanceInfoRef.current = null;
          handleGiftCancel(true);
        }}
        onRedeem={() => {
          const applyData = {
            cardNumber: giftCardBalanceInfo.accountNumber,
            ...(isSecurityCode && giftCardBalanceInfo.securityCode ? { securityCode: giftCardBalanceInfo.securityCode } : {}),
            method: giftCardBalanceInfo?.method || giftCardNumber?.method || 'type',
            paymentAmount: giftCardBalanceInfo?.paymentAmount || paymentAmount,
            fromBalanceScreen: true
          };
          onSubmit(applyData);
        }}
        serverAppTheme={serverAppTheme}
        currencySymbol={currencySymbol}
        landscapePaymentMode={paymentLandscapeOrientation}
        showCheckSeat={showCheckSeat}
      />
    );
  }

  return (
    <div ref={ref} className={cn("col-12 w-100 h-100 px-0")}>
      <div className={cn("px-0 h-90")}>
        {/* Swipe Button */}
        {giftCardSupportsSwipe && (
          <div
            className={cn("d-flex px-0 flex-column align-items-center justify-content-center", "col-12 py-0", showCheckSeatVar ? "mt-1" : "mt-3")}
            style={{ height: showCheckSeatVar ? "40px" : "8.6vh" }}
          >
            <TouchableButton
              type="submit"
              className={cn(
                "btn-ripple text-center fw-600 rounded border-0 text-white od-primary-btn-bg-color od-primary-btn-font-color d-flex align-items-center justify-content-center col-10 fs_24"
              )}
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
                height: showCheckSeatVar ? "40px" : "8.6vh",
              }}
              onClick={(e) => {
                e.preventDefault();
                openCardPopUp();
              }}
              rippleEffect={true}
            >
              {LABEL().GS_CLICK_TO_SWIPE_CARD}
            </TouchableButton>
          </div>
        )}

        {/* OR Text */}
        {giftCardSupportsSwipe && (
          <div className={cn("fw-600 col-12 px-0 d-flex align-items-center justify-content-center text-center", showCheckSeatVar ? "my-1" : "my-2")}>
            {" "}
            <span> OR </span>
          </div>
        )}

        {/* Input Fields */}
        <div className={cn("col-12", "px-1 d-flex flex-column align-items-center mt-2")}>
          <div className={cn("col-12 px-0 d-flex", isSecurityCode ? "justify-content-between" : "justify-content-center")}>
            <div className={cn("position-relative", isSecurityCode ? "col-6 pr-1" : "col-12")}>
              <input
                value={getInput("cardNumber")}
                className={cn("form-control rounded-0 fs_24 pl-3")}
                type="text"
                style={{
                  height: showCheckSeatVar ? "40px" : "8.6vh",
                  backgroundColor: serverAppTheme?.inputBg,
                  border: "none",
                  borderBottom: serverAppTheme?.inputBorder_Bottom,
                  color: serverAppTheme?.primary_text,
                  "--placeholder-color": serverAppTheme?.input_placeholder,
                  paddingRight: "3rem",
                }}
                id="cardNumber"
                name="cardNumber"
                onFocus={() => {
                  handleChangeInput("cardNumber");
                  setActiveElement("cardNumber");
                  handleBlur();
                }}
                placeholder={LABEL().GS_CLICK_TO_ENTER_CARD_NUMBER}
              />
              {inputs?.cardNumber?.length > 0 && (
                <TouchableDiv
                  role="presentation"
                  className="position-absolute"
                  style={{
                    top: "49%",
                    right: "1rem",
                    transform: "translateY(-50%)",
                  }}
                  onClick={() => {
                    handleGiftCancel(false);
                    setEmpty("cardNumber");
                    setActiveElement("cardNumber");
                  }}
                >
                  <Cross fill={serverAppTheme?.iconcolor} />
                </TouchableDiv>
              )}
            </div>
            {isSecurityCode && (
              <div className="col-6 pl-1 position-relative">
                <input
                  value={getInput("securityCode")}
                  className={cn("form-control rounded-0 fs_24 pl-3")}
                  type="text"
                  style={{
                    height: showCheckSeatVar ? "40px" : "8.6vh",
                    backgroundColor: serverAppTheme?.inputBg,
                    border: "none",
                    borderBottom: serverAppTheme?.inputBorder_Bottom,
                    color: serverAppTheme?.primary_text,
                    "--placeholder-color": serverAppTheme?.input_placeholder,
                    paddingRight: "3rem",
                  }}
                  id="securityCode"
                  name="securityCode"
                  onFocus={() => {
                    handleChangeInput("securityCode");
                    setActiveElement("securityCode");
                    handleBlur();
                  }}
                  placeholder={LABEL().GS_CLICK_TO_ENTER_SECURITY_CODE}
                />
                {inputs?.securityCode?.length > 0 && (
                  <TouchableDiv
                    role="presentation"
                    className="position-absolute"
                    style={{
                      top: "49%",
                      right: "1.4rem",
                      transform: "translateY(-50%)",
                    }}
                    onClick={() => {
                      handleGiftCancel(false);
                      setEmpty("securityCode");
                      setActiveElement("securityCode");
                    }}
                  >
                    <Cross fill={serverAppTheme?.iconcolor} />
                  </TouchableDiv>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Keyboard */}
        <div
          className={cn("p-2 position-fixed w-100")}
          style={{
            bottom: showCheckSeatVar ? "12%" : "15%",
            left: 0,
            backgroundColor: serverAppTheme?.keyBoard_Bg_Color,
          }}
        >
          <Keyboard
            onClickBtn={onClickBtn}
            type="number"
            btnSize="btn15"
            customClass="fs-30"
            maxLength={30}
            tableKeyHeight
            setinputEmpty={handleSetInputEmpty}
          />
        </div>
      </div>

      {/* Bottom Buttons */}
      <div
        className={showCheckSeatVar
          ? "d-flex align-items-center mt-2 col-12 px-0 justify-content-center position-absolute"
          : "d-flex align-items-center mt-3 col-12 px-0 justify-content-center position-absolute"
        }
        style={{ bottom: showCheckSeatVar ? "0.5%" : "1%" }}
      >
        <TouchableButton
          className={cn(
            "col-5 mr-1 btn-ripple d-flex justify-content-center align-items-center rounded fs_24 fw-600"
          )}
          style={{
            height: showCheckSeatVar ? "40px" : "8.6vh",
            backgroundColor: serverAppTheme?.OFF_Premise_Btn,
            border: serverAppTheme?.cancleBtn_Border,
            color: serverAppTheme?.cancleBtn_font,
            borderRadius: "8px",
          }}
          onClick={(e) => {
            e.preventDefault();
            window.sessionStorage.removeItem("giftCardpayment");
            handleBackButton();
          }}
          rippleEffect={true}
        >
          {LABEL().GS_CANCEL}
        </TouchableButton>
        <TouchableButton
          type="submit"
          className={cn(
            "col-5 ml-1 border-0 btn-ripple d-flex justify-content-center align-items-center rounded fs_24 fw-600 ",
            "od-primary-btn-bg-color od-primary-btn-font-color"
          )}
          style={{
            height: showCheckSeatVar ? "40px" : "8.6vh",
            backgroundColor: serverAppTheme?.secondaryBtn,
            color: serverAppTheme?.btn_font_color,
            borderRadius: "8px",
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!inputs?.cardNumber || inputs?.cardNumber.length <= 0) {
              handleErrorPopUp(CUSTOM_MESSAGES().PLEASE_ENTER_THE_CARD_NUMBER);
              return;
            }

            if (isSecurityCode && (!inputs?.securityCode || inputs?.securityCode.length <= 0)) {
              handleErrorPopUp(CUSTOM_MESSAGES().PLEASE_ENTRE_THE_SECURITY_CODE);
              return;
            }

            if (giftCardBalanceCheck) {
              const balanceCheckData = {
                accountNumber: inputs.cardNumber,
                ...(isSecurityCode && inputs.securityCode ? { securityCode: inputs.securityCode } : {}),
                method: giftCardNumber?.method || "type",
              };
              previousBalanceInfoRef.current = null;
              giftCardBalanceCheck(balanceCheckData);
            } else {
              onSubmit({ ...inputs, method: giftCardNumber?.method || "type" });
            }
          }}
          rippleEffect={true}
        >
          {LABEL().OS_ADD_A_GIFT_CARD || "Add a Gift Card"}
        </TouchableButton>
      </div>
    </div>
  );
};

const mapStateToProp = ({ payment }) => ({
  paymentLandscapeOrientation: payment.paymentLandscapeOrientation
})

export default connect(mapStateToProp)(GiftCardLandscapeMode);
